export default __webpack_public_path__ + "bb3a92c2fc213d94dcc37e7eaf931a4f.ttf";